import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Banner from "components/mis-survey/sections/banner/Banner";
import styles from "./survey.module.css";
import { IoIosArrowRoundForward } from "react-icons/io";
import { Controller, useForm, useWatch } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import preventionImage from "images/headerimges/mis-survey/prevention-banner.svg";
import {
	conditionalQuizzes as conditionalQuizzesFn,
	generateQuizSchema,
	transformUserResponse,
} from "utils/helpers";
import DropDownInput from "components/ui/DropDownInput";
import toast from "react-hot-toast";
import {
	useGetSectionById,
	useGetSectionQuestions,
	useSubmitUATSurveyData,
} from "api/hooks";
import CountryPicker from "components/mis-survey/CountryPicker";
import { useDispatch, useSelector } from "react-redux";
import { setRespondent, setResponses } from "store/features/misSurveySlice";
import RadioInputs from "components/ui/RadioInputBoxes";
import SolinaCheckboxes from "components/ui/SolinaCheckbox";
import { secureStorage } from "utils/encryptionUtil";
import { submitUATSurvey } from "api/services/mis-survey-service";
import QuestionSnackbar from "components/ui/QuestionSnackbar";
import MSDDOBPicker from "components/mis-survey/MSDYearPicker";
import MsdTextBoxInput from "components/ui/MsdTextBox";

let nextSectionId = null;
let historyStatus = true;

const MSDProviderSurvey = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { responses, localRespondent } = useSelector(
		(state) => state.misSurvey
	);

	const sessionAgentNumber =
		secureStorage.getSession("::agent::us-mls") || "";
	const sessionChannel = secureStorage.getSession("::channel::us-mls") || "";

	const [emptyOthersValue, setEmptyOthersValue] = useState(false);
	const [phoneError, setPhoneError] = useState(false);
	const [phoneError2, setPhoneError2] = useState(false);
	const [isDateInValid, setIsDateInValid] = useState(false);

	const [enabled, setEnabled] = useState(false);
	const [userDOB, setUserDOB] = useState(null);
	const [otherQuizText, setOtherQuizText] = useState({});
	const [hasMissingQuestions, setHasMissingQuestions] = useState(false);

	const getQuestions = useGetSectionQuestions(nextSectionId);

	const initialConditionalQuizzes = conditionalQuizzesFn([]);

	let sectionHistoryData = secureStorage.getLocal("msdPHistory") ?? [];

	const hiddenQuizzes = useRef(
		JSON.parse(sessionStorage.getItem("hidden:::msdp::keys")) ??
			initialConditionalQuizzes
	);
	const getCurrentSection = useGetSectionById(Number(nextSectionId));

	const falseSection =
		Number(nextSectionId) <
			parseInt(secureStorage.getSession("start_section")) ||
		Number(nextSectionId) >
			parseInt(secureStorage.getSession("end_section"));

	const { isLoading } = useSubmitUATSurveyData({
		onSuccess: () => {
			toast.success("survey submitted successfully");
		},
		onError: (error) => {
			const errorMessage = error?.response?.data?.message;
			if (Array.isArray(errorMessage) && errorMessage.length > 1) {
				toast.error("An error occured, please try again");
			} else {
				toast.error(
					errorMessage || "unable to submit survey, please try again"
				);
			}
		},
	});

	const formSchema = generateQuizSchema(
		getQuestions?.data?.data ?? [],
		hiddenQuizzes
	);

	const {
		control,
		handleSubmit,
		setValue,
		register,
		formState: { errors },
	} = useForm({
		resolver: zodResolver(formSchema),
		defaultValues: responses?.[nextSectionId],
	});

	const formData = useWatch({ control });

	useEffect(() => {
		dispatch(setResponses({ currentSection: nextSectionId, formData }));
		hiddenQuizzes.current.forEach((id) =>
			setValue(id.toString(), undefined)
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [formData, nextSectionId]);

	const onSubmit = (data) => {
		hiddenQuizzes.current.forEach((id) =>
			setValue(id.toString(), undefined)
		);
		if (
			Number(nextSectionId) ===
			parseInt(secureStorage.getSession("end_section"))
		) {
			transformUserResponse(data, otherQuizText, (responses) => {
				submitUATSurvey({
					survey_id: parseInt(process.env.REACT_APP_MSD_P_ID),
					channel: sessionChannel !== "" ? sessionChannel : "direct",
					agent:
						sessionAgentNumber !== ""
							? Number(sessionAgentNumber)
							: null,
					survey_code: localRespondent?.survey_code,
					section_id: Number(nextSectionId),
					respondent: {
						phone_number: localRespondent?.phone_number,
						longitude: localRespondent?.longitude,
						latitude: localRespondent?.latitude,
						state: localRespondent?.state,
						town: localRespondent?.town,
						lga: localRespondent?.lga,
						// category: "PPMV",
					},
					response: responses,
					is_survey_end: isEndOfSurvey,
				});
			});
		} else {
			transformUserResponse(data, otherQuizText, (responses) => {
				submitUATSurvey({
					survey_id: parseInt(process.env.REACT_APP_MSD_P_ID),
					channel: sessionChannel !== "" ? sessionChannel : "direct",
					agent:
						sessionAgentNumber !== ""
							? Number(sessionAgentNumber)
							: null,
					survey_code: localRespondent?.survey_code,
					section_id: Number(nextSectionId),
					respondent: {
						phone_number: localRespondent?.phone_number,
						longitude: localRespondent?.longitude,
						latitude: localRespondent?.latitude,
						state: localRespondent?.state,
						town: localRespondent?.town,
						lga: localRespondent?.lga,
						// category: "PPMV",
					},
					response: responses,
					is_survey_end: isEndOfSurvey,
				});
			});
		}

		handlelNextSection();
	};

	const isEndOfSurvey =
		Number(nextSectionId) === secureStorage.getSession("end_section");

	const handlelNextSection = () => {
		if (isEndOfSurvey) {
			nextSectionId = null;
		} else {
			nextSectionId = sectionHistoryData.shift();
			secureStorage.setLocal("msdPHistory", sectionHistoryData);
		}
		setTimeout(() => {
			if (isEndOfSurvey) {
				navigate("/ml-thank-you", { replace: true });
			}
			setEnabled(false);
		}, 400);
	};

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	}, []);

	useEffect(() => {
		sectionHistoryData = secureStorage.getLocal("msdPHistory") ?? [];

		if (!isEndOfSurvey) {
			nextSectionId = sectionHistoryData[0];
		}

		if (!nextSectionId) {
			sectionHistoryData.shift();
			secureStorage.setLocal("msdPHistory", sectionHistoryData);
			historyStatus = false;
		}
	}, []);

	useEffect(() => {
		if (getQuestions?.data?.data && hiddenQuizzes.current?.length <= 0) {
			sessionStorage.setItem(
				"hidden:::msdp::keys",
				JSON.stringify(initialConditionalQuizzes)
			);
			hiddenQuizzes.current = initialConditionalQuizzes;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [getQuestions?.data?.data]);

	useEffect(() => {
		const hasFormErrors = errors && Object.keys(errors).length > 0;
		setHasMissingQuestions(hasFormErrors);
	}, [errors]);

	const updateLocalRespondent = (age, year) => {
		setUserDOB({
			age,
			year,
		});
		dispatch(
			setRespondent({
				...localRespondent,
				phone_number: localRespondent?.phone_number,
				age: year === "" ? 0 : age,
				year_of_birth: year,
			})
		);
	};

	const updateStateLocation = (locationData) => {
		dispatch(
			setRespondent({
				...localRespondent,
				longitude: locationData?.longitude,
				latitude: locationData?.latitude,
				state: locationData?.userLocation?.state,
				town: locationData?.userLocation?.town,
				lga: locationData?.userLocation?.lga,
			})
		);
	};

	const updateHiddenQuizes = (logicObj) => {
		// logicObj
		const allQuestions = getQuestions.data.data;
		const currentQuizIndex = allQuestions.findIndex(
			(q) => q.quiz_id === logicObj?.currentId
		);
		const nextIndex = allQuestions.findIndex(
			(q) => q.quiz_id === logicObj?.targetedId
		);

		const lastQuizId = allQuestions?.[allQuestions?.length - 1]?.quiz_id;
		const lastQuizIndex = allQuestions.findIndex(
			(q) => q.quiz_id === lastQuizId
		);

		const quizesInbetween = allQuestions
			.slice(
				currentQuizIndex + 1,
				nextIndex === -1 ? lastQuizIndex + 1 : nextIndex
			)
			.map((q) => q.quiz_id);

		//REMOVE action indicates adding the quizes in between that should be skipped
		if (logicObj?.action === "REMOVE") {
			const newHiddenQuizzes = hiddenQuizzes.current?.filter(
				(id) => id !== logicObj?.targetedId
			);

			const updatedHiddenQuizes = [
				...new Set([...newHiddenQuizzes, ...quizesInbetween]),
			];
			sessionStorage.setItem(
				"hidden:::msdp::keys",
				JSON.stringify(updatedHiddenQuizes)
			);
			hiddenQuizzes.current = updatedHiddenQuizes;
		}

		//ADD action indicates removing the previous hidden quizes in between
		if (logicObj?.action === "ADD") {
			const newHiddenQuizzes = hiddenQuizzes.current?.filter(
				(id) => !quizesInbetween?.includes(id)
			);
			const nestedChildQuizIds = [];

			const targetedQuiz = getQuestions?.data?.data?.find(
				(quiz) => quiz.quiz_id === logicObj?.targetedId
			);

			targetedQuiz?.options?.forEach((option) => {
				if (option?.next_question_id) {
					nestedChildQuizIds.push(option.next_question_id);
				}
			});

			const updatedHiddenQuizes = [
				...new Set([...newHiddenQuizzes, ...nestedChildQuizIds]),
			];
			sessionStorage.setItem(
				"hidden:::msdp::keys",
				JSON.stringify(updatedHiddenQuizes)
			);

			hiddenQuizzes.current = updatedHiddenQuizes;
		}
	};

	const isButtonDisabled =
		getQuestions.isLoading ||
		!getQuestions.data ||
		falseSection ||
		isLoading ||
		emptyOthersValue ||
		isDateInValid;

	return (
		<section className={styles.container}>
			<Banner
				title={getCurrentSection.data?.data?.[0]?.section_type ?? ""}
				description={""}
				imageURL={preventionImage}
			/>

			<form
				onSubmit={handleSubmit(onSubmit)}
				data-testid="main_survey_form"
			>
				{getQuestions.isLoading && (
					<div className={styles.form_earning}>
						<p className={"!text-gray-500"}>
							Your section questions are loading, please wait....
						</p>
					</div>
				)}

				{getQuestions?.data?.data
					?.filter(
						(quiz) => !hiddenQuizzes.current.includes(quiz?.quiz_id)
					)
					.map((quiz, i) => {
						return (
							<React.Fragment key={i + 1}>
								{
									<>
										{quiz.quiz_type === "PLAIN_TEXT" &&
											quiz.form_element === "DATE" && (
												<Controller
													name={quiz.quiz_id.toString()}
													control={control}
													render={() => (
														<div
															className={
																styles.form_education
															}
														>
															<div className="flex mb-1 gap-2">
																<span className="text-center bg-primary text-white py-[2px] px-1 rounded-sm !text-sm mr-2 block h-6">
																	{i + 1}
																</span>
																<p>
																	In what year
																	were you
																	born?
																</p>
															</div>
															<MSDDOBPicker
																onDOBChange={(
																	age,
																	year
																) => {
																	setValue(
																		quiz.quiz_id.toString(),
																		String(
																			year +
																				"#dob#"
																		),
																		{
																			shouldValidate: true,
																			shouldTouch: true,
																			shouldDirty: true,
																		}
																	);
																	updateLocalRespondent(
																		age,
																		year
																	);
																}}
																initialAge={
																	localRespondent?.age ??
																	null
																}
																initialYear={
																	localRespondent?.year_of_birth ??
																	null
																}
																hasInvalidDate={(
																	isInvalid
																) => {
																	setIsDateInValid(
																		isInvalid
																	);
																}}
															/>

															{Boolean(
																errors?.[
																	quiz.quiz_id
																]
															) && (
																<small className="text-danger">
																	{errors?.[
																		quiz
																			.quiz_id
																	]
																		? "this question is required"
																		: ""}
																</small>
															)}
															{isDateInValid && (
																<small className="text-danger">
																	please use
																	the calendar
																	icon to
																	select a
																	proper date
																</small>
															)}
														</div>
													)}
												/>
											)}

										{quiz.quiz_type === "PLAIN_TEXT" &&
											quiz.form_element ===
												"LOCATION" && (
												<Controller
													name={quiz.quiz_id.toString()}
													control={control}
													render={() => (
														<div
															className={
																styles.form_education
															}
														>
															<CountryPicker
																onLocationChange={(
																	locationData
																) => {
																	updateStateLocation(
																		locationData
																	);
																	setValue(
																		quiz.quiz_id.toString(),
																		locationData.latitude &&
																			locationData.longitude
																			? locationData.latitude.toString() +
																					"," +
																					locationData.longitude.toString()
																			: "",
																		{
																			shouldValidate: true,
																			shouldTouch: true,
																			shouldDirty: true,
																		}
																	);
																}}
																index={i}
															/>

															{Boolean(
																errors?.[
																	quiz.quiz_id
																]
															) && (
																<small className="text-danger">
																	{errors?.[
																		quiz
																			.quiz_id
																	]
																		? "this question is required"
																		: ""}
																</small>
															)}
														</div>
													)}
												/>
											)}

										{quiz.quiz_type === "PLAIN_TEXT" &&
											quiz.form_element ===
												"TEXT-BOX" && (
												<Controller
													name={quiz.quiz_id.toString()}
													control={control}
													render={({ field }) => (
														<MsdTextBoxInput
															field={field}
															question={
																quiz.quiz_text
															}
															optionId={
																quiz.quiz_id
															}
															{...(register(
																quiz.quiz_id.toString()
															),
															{
																required: true,
															})}
															hasError={Boolean(
																errors[
																	quiz.quiz_id
																]
															)}
															errorMessage={
																errors?.[
																	quiz.quiz_id
																]
																	? "this question is required"
																	: ""
															}
															onLogicChange={(
																logic
															) => {
																updateHiddenQuizes(
																	logic
																);
															}}
															hasOthersError={(
																hasError
															) => {
																setEmptyOthersValue(
																	hasError
																);
															}}
															hasPhoneError1={(
																hasError
															) => {
																setPhoneError(
																	hasError
																);
															}}
															hasPhoneError2={(
																hasError
															) => {
																setPhoneError2(
																	hasError
																);
															}}
															index={i}
															onOtherTextChange={({
																id,
																text,
																type,
															}) => {
																setOtherQuizText(
																	(
																		prevValue
																	) => {
																		return {
																			...prevValue,
																			[id]: {
																				id,
																				text,
																				type,
																			},
																		};
																	}
																);
															}}
														/>
													)}
												/>
											)}

										{quiz.quiz_type === "SINGLE_SELECT" &&
											quiz.form_element === "RADIO" && (
												<Controller
													name={quiz.quiz_id.toString()}
													control={control}
													render={({ field }) => (
														<RadioInputs
															field={field}
															question={
																quiz.quiz_text
															}
															{...(register(
																quiz.quiz_id.toString()
															),
															{
																required: true,
															})}
															quizOptions={
																quiz.options
															}
															index={i}
															hasError={Boolean(
																errors[
																	quiz.quiz_id
																]
															)}
															errorMessage={
																errors?.[
																	quiz.quiz_id
																]
																	? "this question is required"
																	: ""
															}
															onLogicChange={(
																logic
															) => {
																updateHiddenQuizes(
																	logic
																);
															}}
														/>
													)}
												/>
											)}

										{quiz.quiz_type === "SINGLE_SELECT" &&
											quiz.form_element ===
												"DROP-DOWN" && (
												<Controller
													name={quiz.quiz_id.toString()}
													control={control}
													render={({ field }) => (
														<DropDownInput
															hideOthers={false}
															field={field}
															question={
																quiz.quiz_text
															}
															index={i}
															quizOptions={
																quiz.options
															}
															{...(register(
																quiz.quiz_id.toString()
															),
															{
																required: true,
															})}
															hasError={Boolean(
																errors[
																	quiz.quiz_id
																]
															)}
															errorMessage={
																errors?.[
																	quiz.quiz_id
																]
																	? "this question is required"
																	: ""
															}
															onLogicChange={(
																logic
															) => {
																updateHiddenQuizes(
																	logic
																);
															}}
															hasOthersError={(
																hasError
															) => {
																setEmptyOthersValue(
																	hasError
																);
															}}
															onOtherTextChange={({
																id,
																text,
															}) => {
																setOtherQuizText(
																	(
																		prevValue
																	) => {
																		return {
																			...prevValue,
																			[id]: {
																				id,
																				text,
																			},
																		};
																	}
																);
															}}
														/>
													)}
												/>
											)}

										{quiz.quiz_type === "MULTIPLE_SELECT" &&
											quiz.form_element ===
												"CHECKBOX" && (
												<div>
													<Controller
														name={quiz.quiz_id.toString()}
														control={control}
														render={({ field }) => (
															<SolinaCheckboxes
																field={field}
																setValue={
																	setValue
																}
																hasOthersError={(
																	hasError
																) => {
																	setEmptyOthersValue(
																		hasError
																	);
																}}
																question={
																	quiz.quiz_text
																}
																index={i}
																quizOptions={
																	quiz.options
																}
																{...(register(
																	quiz.quiz_id.toString()
																),
																{
																	required: true,
																})}
																hasError={Boolean(
																	errors[
																		quiz
																			.quiz_id
																	]
																)}
																errorMessage={
																	errors?.[
																		quiz
																			.quiz_id
																	]
																		? "select at least one option"
																		: ""
																}
																onLogicChange={(
																	logic
																) => {
																	updateHiddenQuizes(
																		logic
																	);
																}}
															/>
														)}
													/>
												</div>
											)}
									</>
								}
							</React.Fragment>
						);
					})}

				<div className="!flex !flex-wrap !items-center !gap-2">
					{/* <button type="submit" disabled={false}>
                        {isLoading
                            ? "Submitting"
                            : `${isEndOfSurvey ? "Submit" : "Next"}`}{" "}
                        <IoIosArrowRoundForward color="white" size={24} />
                    </button> */}
					<button type="submit" disabled={isButtonDisabled}>
						{isLoading
							? "Submitting"
							: `${isEndOfSurvey ? "Submit" : "Next"}`}{" "}
						<IoIosArrowRoundForward color="white" size={24} />
					</button>
				</div>
			</form>

			<QuestionSnackbar
				open={hasMissingQuestions}
				onClose={() => {
					setHasMissingQuestions(false);
				}}
			/>
		</section>
	);
};

export default MSDProviderSurvey;
